import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "../../../i18n";
import { Button } from "../../../components/ui";
import api from "../../../lib/api";
import {
  returnFromOperatorSupport,
  watchOperatorSupportEnd,
} from "../../../lib/operatorSupportSession";

export default function SupportModeBanner() {
  const { supportSession } = useAuth();
  const { t, locale } = useTranslation();
  const [ending, setEnding] = useState(false);
  const [failed, setFailed] = useState(false);
  useEffect(watchOperatorSupportEnd, []);
  useEffect(() => {
    if (!supportSession) return;
    const remaining = new Date(supportSession.expiresAt).getTime() - Date.now();
    const timer = setTimeout(returnFromOperatorSupport, Math.max(0, remaining));
    return () => clearTimeout(timer);
  }, [supportSession]);
  if (!supportSession) return null;
  const end = async () => {
    setEnding(true);
    setFailed(false);
    try {
      await api.post(`/api/admin/support-sessions/${supportSession.id}/end`);
      returnFromOperatorSupport();
    } catch {
      setFailed(true);
      setEnding(false);
    }
  };
  return (
    <aside
      aria-label={t("operatorAdmin.support.mode")}
      className="sticky top-0 z-[60] flex flex-wrap items-center justify-between gap-3 border-b border-warning/40 bg-warning-container px-4 py-3 text-on-warning-container sm:px-6"
    >
      <div className="min-w-0 text-sm">
        <p className="font-semibold">
          {t("operatorAdmin.support.mode")} ·{" "}
          <span className="break-all">{supportSession.userEmail}</span>
        </p>
        <p className="mt-1 text-xs">
          {t("operatorAdmin.support.bannerHint", {
            time: new Date(supportSession.expiresAt).toLocaleTimeString(
              locale === "de" ? "de-DE" : "en-GB",
              {
                hour: "2-digit",
                minute: "2-digit",
              },
            ),
          })}
        </p>
        {failed && (
          <p role="alert" className="mt-1 text-xs">
            {t("operatorAdmin.support.endFailed")}
          </p>
        )}
      </div>
      <Button variant="secondary" icon="logout" onClick={end} disabled={ending}>
        {t("operatorAdmin.support.end")}
      </Button>
    </aside>
  );
}
